import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LanguageStateService } from '../application-service/language-state.service';

/**
 * Posílá na backend jazyk přihlášeného uživatele.
 *
 * Dřív byl `Accept-Language: cs` natvrdo ve sdílené konstantě `headers`, takže serverové
 * hlášky i e-maily chodily česky i anglickému uživateli.
 *
 * Závislost je záměrně jen na `LanguageStateService`, která sama nic neinjektuje.
 * Kdyby si interceptor sáhl na `LanguageService` (a přes ni na `TranslateService`),
 * vznikne cyklus v DI — první HTTP request aplikace je stažení překladů, takže by se
 * `HTTP_INTERCEPTORS` resolvovaly znovu uprostřed vlastního resolvování (`NG0200`).
 */
@Injectable()
export class LanguageInterceptor implements HttpInterceptor {

  constructor(
    private languageState: LanguageStateService,
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request.clone({
      setHeaders: { 'Accept-Language': this.languageState.current },
    }));
  }
}
